import { decryptKey } from "./constants";

var CryptoJS = require("crypto-js");

export const setLocalStorageItem = (key: string, value: string) => {
  let encryptedData = CryptoJS.AES.encrypt(value, decryptKey).toString();
  localStorage.setItem(key, encryptedData);
};

export const getLocalStorageItem = (key: string) => {
  if (localStorage.getItem(key)) {
    var bytes = CryptoJS.AES.decrypt(localStorage.getItem(key), decryptKey);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (key === "accessToken") {
      return originalText;
    }
    return JSON.parse(originalText);
  }
  return "";
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};
